<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M193.536 78.7136C185.894 76.7808 178.054 81.4528 176.122 89.0944L169.811 114.042V25.4144C169.811 17.344 163.27 10.8032 155.2 10.8032C150.976 10.8032 147.168 12.6016 144.499 15.4688C142.893 9.15201 137.165 4.48001 130.349 4.48001C123.533 4.48001 117.69 9.24801 116.147 15.6672C113.472 12.6784 109.587 10.8032 105.267 10.8032C97.1968 10.8032 90.656 17.344 90.656 25.4144V38.8096C89.6 38.5472 88.4992 38.4 87.3664 38.4C79.7696 38.4 73.6064 44.5632 73.6064 52.16V135.405C73.6064 135.718 73.632 136.026 73.6512 136.339C73.76 153.427 78.1568 165.952 83.9424 175.162C84.96 176.781 86.144 178.33 87.456 179.808V238.47H166.432V189.242C177.152 181.952 184.845 171.142 187.981 158.221C188 158.227 188.026 158.234 188.045 158.246C188.314 157.6 188.544 156.928 188.723 156.224L203.923 96.1344C205.856 88.4928 201.184 80.6528 193.542 78.72L193.536 78.7136ZM90.6496 148.89L90.5088 148.774C90.5536 148.762 90.6048 148.755 90.6496 148.742V148.89Z"
      class="fill-brand-100"
    />
    <path
      d="M195.546 90.368C193.338 96.4288 192.973 103.59 192.973 103.59C192.499 105.85 194.598 107.763 197.011 108.269L200.768 108.589L203.917 96.1344C205.062 91.6096 203.891 87.0208 201.165 83.6288C199.027 85.2096 196.397 88.032 195.546 90.3744V90.368Z"
      class="fill-brand-300"
    />
    <path
      d="M87.456 225.382L163.52 238.458H166.426V205.811L87.456 186.598V225.382Z"
      class="fill-brand-500"
    />
    <path
      d="M128.474 150.15L73.664 137.216C73.92 153.843 78.2528 166.106 83.936 175.149C84.9536 176.768 86.1376 178.317 87.4496 179.795V186.592L166.426 205.805V189.229C175.558 183.021 182.496 174.253 186.285 163.802L128.467 150.15H128.474ZM90.6496 148.736V148.883L90.5088 148.774C90.5536 148.762 90.5984 148.749 90.6496 148.736Z"
      class="fill-brand-300"
    />
    <path
      d="M169.811 56.8448L73.6 78.7328V125.165L169.811 104.026V56.8448Z"
      class="fill-brand-300"
    />
    <path
      d="M165.626 130.592L169.811 114.048V104.026L73.6 125.165V135.392C73.6 135.706 73.6256 136.013 73.6448 136.32C73.6448 136.621 73.6576 136.909 73.664 137.21L128.467 150.15L162.701 142.118L165.619 130.592H165.626Z"
      class="fill-brand-500"
    />
    <path
      d="M164.07 250.957C168.576 250.957 172.224 247.302 172.224 242.803V219.104H81.6576V242.803C81.6576 247.309 85.312 250.957 89.8112 250.957H164.07Z"
      class="fill-secondary-500"
    />
  </svg>
</template>

<script>
  export default {
    name: 'SickLeave'
  }
</script>
